import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/forms`;
export const list = (wsId) => apiClient.get(base(wsId)).then(r => r.data);
export const create = (wsId, dto) => apiClient.post(base(wsId), dto).then(r => r.data);
export const update = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/${id}`, dto).then(r => r.data);
export const remove = (wsId, id) => apiClient.delete(`${base(wsId)}/${id}`).then(r => r.data);
export const publish = (wsId, id) => apiClient.patch(`${base(wsId)}/${id}/publish`).then(r => r.data);
export const listSubmissions = (wsId, id) => apiClient.get(`${base(wsId)}/${id}/submissions`).then(r => r.data);
export const submit = (wsId, id, data) => apiClient.post(`${base(wsId)}/${id}/submit`, data).then(r => r.data);
